export default __webpack_public_path__ + "static/chessboard-4e101a9ba612107c69e5dceecc9351c5.jpg";